import StoreMenu from './StoreMenu'
import ccStoreMenuNew from './StoreMenuNew'
export let StoreMenuNew = ccStoreMenuNew
export default  StoreMenu



// WEBPACK FOOTER //
// ./components/pages/order/StoreMenu/index.js